import { Empty, Form, Radio, Space, Table } from 'antd'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { PATH_FRONT } from '../../../../routes/path'
import { Add, ArrowLeft2, ArrowRight2 } from 'iconsax-react'
import Column from 'antd/es/table/Column'
import { useTranslation } from 'react-i18next'
import http from '../../../../../security/Http'
import url from '../../../../../Development.json'
import {
    format,
    addMonths,
    addWeeks,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    eachDayOfInterval,
} from 'date-fns'
import { enqueueSnackbar } from 'notistack'
import { ja } from 'date-fns/locale'
import moment from 'moment'
import Loader from '../../../../Loader'
import ShiftMonthCalendar from './ShiftMonthCalendar'
import ShiftWeekMobile from './ShiftWeekMobile'
import ShiftLegend from './ShiftLegend'
import {
    getShiftBadgeClassByIndex,
    getShiftLetter,
} from './shiftLabelUtils'

const VIEW_WEEK = 'week'
const VIEW_MONTH = 'month'

const renderShiftCell = (item, dateKey) => {
    const shifts = item?.shiftData?.[dateKey]

    if (!shifts) {
        return (
            <ul>
                <li>
                    <span className="label"></span>
                    <span className="shift_badge" style={{ visibility: 'hidden' }}></span>
                </li>
            </ul>
        )
    }

    return (
        <ul>
            {shifts.map((dt, ind) =>
                dt !== '' ? (
                    <li key={ind}>
                        <span className="label">{getShiftLetter(dt)}</span>
                        <span className={`shift_badge ${getShiftBadgeClassByIndex(ind)}`}></span>
                    </li>
                ) : (
                    <li key={ind}></li>
                )
            )}
        </ul>
    )
}

function ShiftList() {
    const { t } = useTranslation()
    const lang = localStorage.getItem('i18nextLng')
    const frameLabel = t('table_title.Frame')
    const Token = localStorage.getItem('token')
    const [shift, setShift] = useState([])
    const [staffshift, setStaffShift] = useState([])
    const [currentDate, setCurrentDate] = useState(new Date())
    const [viewMode, setViewMode] = useState(VIEW_WEEK)
    const [isLoading, setIsLoading] = useState(true)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767)

    const permissionData = localStorage.getItem('auth-storage')
    const parsedpermission = JSON.parse(permissionData)
    const permission = parsedpermission?.state?.permission

    const { rangeStart, rangeEnd, weekDays } = useMemo(() => {
        const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 })
        const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 })
        const monthStart = startOfMonth(currentDate)
        const monthEnd = endOfMonth(currentDate)

        const start = viewMode === VIEW_WEEK ? weekStart : monthStart
        const end = viewMode === VIEW_WEEK ? weekEnd : monthEnd

        return {
            rangeStart: start,
            rangeEnd: end,
            weekDays: eachDayOfInterval({ start: weekStart, end: weekEnd }),
        }
    }, [currentDate, viewMode])

    const newdatestart = format(rangeStart, 'yyyy-MM-d')
    const newdateend = format(rangeEnd, 'yyyy-MM-d')

    const getshifttime = useCallback(() => {
        http.callApi(url.getshift, [], {
            headers: { authorization: 'Bearer ' + Token, lang },
        })
            .then((res) => {
                setShift(res.data)
            })
            .catch(() => {})
    }, [Token, lang])

    const getallshift = useCallback(() => {
        setIsLoading(true)
        http.get(
            process.env.REACT_APP_BASE_URL +
                `/admin/staffshift?startDay=${newdatestart}&&endDay=${newdateend}`,
            [],
            {
                headers: { authorization: 'Bearer ' + Token, lang },
            }
        )
            .then((res) => {
                setStaffShift(res?.data)
                setIsLoading(false)
            })
            .catch((error) => {
                setIsLoading(false)
                enqueueSnackbar(error, { variant: 'error' }, { autoHideDuration: 1000 })
            })
    }, [Token, lang, newdatestart, newdateend])

    useEffect(() => {
        getshifttime()
    }, [getshifttime])

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 767)
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [])

    useEffect(() => {
        getallshift()
    }, [getallshift])

    const handleMonthChange = (amount) => {
        setCurrentDate(addMonths(currentDate, amount))
    }

    const handleWeekChange = (amount) => {
        setCurrentDate(addWeeks(currentDate, amount))
    }

    const formatMonthLabel = () =>
        lang === 'en'
            ? format(currentDate, 'MMMM yyyy')
            : format(currentDate, 'yyyy年M月', { locale: ja })

    const formatWeekPeriodLabel = () =>
        lang === 'en'
            ? `${format(rangeStart, 'MMM d')} - ${format(rangeEnd, 'MMM d, yyyy')}`
            : `${format(rangeStart, 'M月d日', { locale: ja })} - ${format(rangeEnd, 'M月d日', { locale: ja })}`

    return (
        <section className="ptb40">
            <div className="fliter_box_card mb30">
                <Form>
                    <Space className="flex-wrap flex_item_ce">
                        {permission?.Shift?.substring(0, 1) === '1' ? (
                            <Form.Item className="mb0">
                                <Link
                                    to={PATH_FRONT.addShift}
                                    className="btn-theme btn-with-icon btn-success flex-row"
                                >
                                    <Add size="24" color="#ffffff" /> {t('Shift.Add_Shift')}
                                </Link>
                            </Form.Item>
                        ) : (
                            ''
                        )}
                        <Form.Item className="mb0 shift-view-toggle">
                            <Radio.Group
                                value={viewMode}
                                onChange={(e) => setViewMode(e.target.value)}
                                optionType="button"
                                buttonStyle="solid"
                            >
                                <Radio.Button value={VIEW_WEEK}>{t('Shift.Week_View')}</Radio.Button>
                                <Radio.Button value={VIEW_MONTH}>{t('Shift.Month_View')}</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </Space>
                </Form>
            </div>
            <div className="custom_card">
                <div className="custom_card_head flex_item_cb flex-wrap mb10">
                    <h4>{t('Shift.Shift_List')}</h4>
                    {(!isMobile || viewMode === VIEW_MONTH) && (
                        <ShiftLegend shiftDefs={shift} lang={lang} frameLabel={frameLabel} />
                    )}
                </div>
                <div className="custom_card_body p10">
                    <div className="shift-list-table custom_table_wrapper">
                        {isLoading ? (
                            <Loader />
                        ) : viewMode === VIEW_MONTH ? (
                            <ShiftMonthCalendar
                                currentDate={currentDate}
                                staffshift={staffshift || []}
                                lang={lang}
                                onMonthChange={handleMonthChange}
                                formatMonthLabel={formatMonthLabel}
                            />
                        ) : isMobile ? (
                            <ShiftWeekMobile
                                staffshift={staffshift || []}
                                shiftDefs={shift}
                                weekDays={weekDays}
                                lang={lang}
                                frameLabel={frameLabel}
                                periodLabel={formatWeekPeriodLabel()}
                                monthLabel={formatMonthLabel()}
                                onPrevWeek={() => handleWeekChange(-1)}
                                onNextWeek={() => handleWeekChange(1)}
                                onPrevMonth={() => handleMonthChange(-1)}
                                onNextMonth={() => handleMonthChange(1)}
                                emptyText={<p>{t('Reports.No_Data')}</p>}
                            />
                        ) : (
                            <Table
                                scroll={{ x: 900 }}
                                dataSource={staffshift}
                                pagination={false}
                                className="text-nowrap"
                                rowKey={(record) => record?._id?.staffId || record?.name}
                                locale={{
                                    emptyText: (
                                        <Empty
                                            description={<p>{t('Reports.No_Data')}</p>}
                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        />
                                    ),
                                }}
                            >
                                <Column
                                    title={
                                        <div className="flex_item_cc">
                                            <a
                                                role="button"
                                                className="lh1 flex_item_cc"
                                                onClick={() => handleMonthChange(-1)}
                                            >
                                                <ArrowLeft2 variant="Bold" color="#0D0B0B" size="24" />
                                            </a>
                                            <h6>{formatWeekPeriodLabel()}</h6>
                                            <a
                                                role="button"
                                                className="lh1 flex_item_cc"
                                                onClick={() => handleMonthChange(1)}
                                            >
                                                <ArrowRight2 variant="Bold" color="#0D0B0B" size="24" />
                                            </a>
                                        </div>
                                    }
                                    className="td_staff_name text-start"
                                    dataIndex="name"
                                    key="name"
                                    fixed="left"
                                    width={160}
                                />
                                <Column
                                    title={
                                        <div className="flex_item_cc">
                                            <a
                                                className="lh1_5 flex_item_cc"
                                                role="button"
                                                onClick={() => handleWeekChange(-1)}
                                            >
                                                <ArrowLeft2 variant="Bold" color="#0D0B0B" size="24" />
                                            </a>
                                        </div>
                                    }
                                    width={48}
                                />
                                {weekDays.map((day) => {
                                    const dateKey = moment(day).format('YYYY-MM-DD')
                                    return (
                                        <Column
                                            key={dateKey}
                                            title={
                                                <div className="flex_item_cc gap2">{format(day, 'd')}</div>
                                            }
                                            className="td_weekday text-center"
                                            width={120}
                                            render={(e, item) => renderShiftCell(item, dateKey)}
                                        />
                                    )
                                })}
                                <Column
                                    title={
                                        <div className="flex_item_cc">
                                            <a
                                                className="lh1 flex_item_cc"
                                                role="button"
                                                onClick={() => handleWeekChange(1)}
                                            >
                                                <ArrowRight2 variant="Bold" color="#0D0B0B" size="24" />
                                            </a>
                                        </div>
                                    }
                                    width={48}
                                />
                            </Table>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ShiftList
